var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"large":"","title":"Histórico de atualização do cadastro"},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('rkm-button',{on:{"click":_vm.close}},[_vm._v(" Fechar ")])]},proxy:true}])},[(_vm.data)?_c('rkm-table',{attrs:{"fields":_vm.fields,"items":_vm.handleHistorico}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }